import React from 'react'

const IconContainer = ({
  children,
  size,
  onClick,
  className,
  active = false,
  activeClass = 'border border-[var(--color-brand-04)]',
}) => {
  return (
    <div className={`relative group flex justify-center items-center ${className}`} onClick={onClick}>
      <div
        className={`absolute rounded-full group-hover:bg-surface-3 z-0 cursor-pointer ${active ? activeClass : ''}`}
        style={{
          width: size * 2 + 12 + 'px',
          height: size * 2 + 12 + 'px',
          // left: -size,
          // top: -size,
        }}></div>
      <i className="z-20 relative ">{children}</i>
    </div>
  )
}

export default IconContainer
